import { render } from "./trash.vue?vue&type=template&id=610633a7&ts=true"
import script from "./trash.vue?vue&type=script&lang=ts"
export * from "./trash.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__